import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let treeChildren = (index, data) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 12; i++) {
      let obj = {};
      let n = ('0' + i).slice(-2);
      obj.title = `${n}`;
      // obj.title = `${i}`;
      obj.align = 'center';
      obj.width = '34';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var divideList = data[0].ball_json[name].nums[n];
        if (row.row.ball_json[name].nums[n] == 0) {
          return <span class="red">{data[row.index].ballList[index]}</span>;
        } else {
          if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{row.row.ball_json[name].nums[n]}</span>;
          } else {
            return <span class="lost_info">{row.row.ball_json[name].nums[n]}</span>;
          }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

let lostChildren = index => {
  var arr = [];
  for (let i = 1; i < 12; i++) {
    var obj = {};
    let ball = ('0' + i).slice(-2);
    obj.title = `${ball}`;
    obj.align = 'center';
    obj.width = '34';
    obj.className = `lost_table_children_${i}`;
    obj.render = (h, row) => {
      var name = `ball${index + 1}`;
      var key = row.row.key;
      var n = row.row.lost[name].nums[ball];
      // console.log(n[key], n, 'asdfasdf');
      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
};

const choose5 = data => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        // key: 'issueId',
        key: 'issue_id',
        className: `table_issueId`,
        width: 150
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 130,
        render: (h, { row }) => {
          return (
            <div class="ball num">
              {row.ballList.map((x, i) => {
                return <span>{x}</span>;
              })}
            </div>
          );
        }
        // render: (h, { row }) => <span class="issue_result">{row.issueResult.join('')}</span>
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    for (let i = 0; i < data[0].ballList.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.width = '300';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.children = treeChildren(i, data);
      arr.push(obj);
    }
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 280
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    for (let i = 0; i < 5; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.width = '300';
      obj.className = `table_info_column_${i}`;
      obj.children = lostChildren(i);
      arr.push(obj);
    }
    return arr;
  };

  return { list, lostList };
};

export default choose5;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jibenzoushi/columns/choose5.js